<section class="login  bg-primary common-img-bg">
    <!-- Authentication card start -->
    <div class="container-login" style="width: 65%;">
        <div class="login-card  auth-body ">

            <!-- Form Search -->
            <form novalidate (ngSubmit)="guardaFormulario(formMailbox)" #formMailbox="ngForm">
                <div class="card">
                    <div class="card-header">
                        <h5>Buzón Anónimo</h5>
                    </div>
                    <div class="form-group text-left">
                        <div class="col" style="margin-top: 20px;">
                            <div class="form-radio">
                                <div class="radio radio-inline">
                                    <label>
                                        <input type="radio" [value]="1" [(ngModel)]="tipoPersona" name="TipoPersona"
                                            (click)="validaTipoPersona(1)" />
                                        <i class="helper"></i>Empleado
                                    </label>
                                </div>
                                <div class="radio radio-inline">
                                    <label>
                                        <input type="radio" [value]="2" [(ngModel)]="tipoPersona" name="TipoPersona"
                                            (click)="validaTipoPersona(2)" />
                                        <i class="helper"></i>Cliente
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <label class=" col-form-label">{{campoPersona}}</label>
                            <i *ngIf="buscando" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            <input type="text" class="form-control" placeholder="Buscar {{campoPersona}}"
                                name="txtClienteEmpleadoBuscar" [(ngModel)]="ModelCasoInusual.nombre"
                                (input)="buscarPersona()" />
                            <div style="color: #dc3545;" *ngIf="viewDropDownError">
                                Escribir nombre completo para obtener un resultado
                            </div>
                            <div style="color: #43A407;"
                                *ngIf="viewDropDown && leyenda === 'Se encontró ' + campoPersona">
                                {{leyenda}}
                            </div>
                        </div>

                        <div class="col">
                            <label class="col-form-label">Alerta</label>
                            <input type='text' disabled='disabled' class="form-control" value='{{tipoAlerta}}'>
                        </div>
                        <div class="col">
                            <label class="col-form-label">Descripción</label>
                            <textarea class="form-control" placeholder='Descripcion' name="descripcion" required
                                [(ngModel)]="casoPreocupante.Descripcion"></textarea>
                        </div>
                    </div>
                    <div class="card-block">
                        <div class="text-right"><button class="btn btn-info" type="submit"
                                [disabled]="!formMailbox.valid">Guardar</button>
                        </div>
                    </div>
                    <!-- Form Search End  -->
                </div>
            </form>
            <!-- end of form -->
        </div>
        <!-- Authentication card end -->
        <!-- end of row -->
        <!-- end of container-fluid -->
    </div>
</section>